// Footer.js
import React from 'react';
import { Container } from 'reactstrap';
import '../styles/Footer.css';

export const Footer = () => {
    return (
        <footer className="footer bg-dark text-white py-4">
            <Container className="text-center">
                <p>© Bitdam Data Center. All rights are "LSIoT", Inc.</p>
                <p>
                    <a href="https://lsiot.co.kr/member/privacy.html" target="_blank" rel="noopener noreferrer" className="text-white">Privacy Policy </a> |
                    <a href="https://lsiot.co.kr/shopinfo/company.html" target="_blank" rel="noopener noreferrer" className="text-white"> Terms of Service</a>
                </p>                
            </Container>
        </footer>
    );
};

export default Footer;